import {
    BANKLISTFORPARTNER_SUCCESS,
    BANKLISTFORPARTNER_FAILED,
    RESET_BANKLISTFORPARTNER,
    LOADING_BANKLISTFORPARTNER,
    NETWORK_ERROR_BANKLISTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";

const resetBankListPartner = () => {
    return { type: RESET_BANKLISTFORPARTNER };
};


const partnerBankListReqList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BANKLISTFORPARTNER });
    await partnerServices
        .post("bankListForPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerBankListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerBankListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_BANKLISTFORPARTNER,
                payload: err
            });
        });
};


function partnerBankListsuccess(data) {
    return {
        type: BANKLISTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerBankListFailed(data) {
    return {
        type: BANKLISTFORPARTNER_FAILED,
        payload: data,
    };
}


export { resetBankListPartner, partnerBankListReqList }